/* import __COLOCATED_TEMPLATE__ from './confirm-replacement.hbs'; */
import Component from '@glimmer/component';
import { formatAddress } from '@banking/ui/utils/address';
export default class ConfirmReplacement extends Component {
  get formattedAddress() {
    return formatAddress(this.args.chosenAddress).join(', ');
  }
}